import React from 'react';
import { Link } from 'react-router-dom';
import Services from "../../api/Services";

import Topimage from '../../images/service/service-bg.jpg'

const ServiceSection = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }





    return (
        <section className={"" + props.hclass}>
            <div className="container-fluid p-0">
                <div className="service-top">
                    <div className="image">
                        <img src={Topimage} alt="service-bg" />
                    </div>
                  <div className="content">
  <h2 className="fade_bottom">
    Creating Landmark Spaces, One Blueprint at a Time
  </h2>

  <p className="fade_bottom">
    YV Reddy Associates delivers end-to-end architectural, interior, and
    turnkey contracting solutions for corporate, commercial, and institutional
    projects. With a strong focus on quality, precision, and functionality, we
    transform visionary concepts into efficient, sustainable, and timeless
    built environments.
  </p>
</div>

                </div>
                <div className="service-wrap">
                    <div className="row">
                        {Services.slice(0, 3).map((service, item) => (
                            <div className="col-lg-3 col-md-6 col-12 fade_bottom" key={item}>
                                <div className="service-card">
                                    <div className="icon">
                                        <img src={service.Icon} alt="icon" />
                                    </div>
                                    <h2><Link onClick={ClickHandler} to={`/service-single/${service.slug}`}>{service.title}</Link></h2>
                                    <p>{service.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ServiceSection;

